import React, { useState, useEffect, useRef } from "react";
import API_BASE_URL from "../../../../Constants";

// Example options for the type dropdown
const TYPE_OPTIONS = ["Select", "Maintenance", "Repair"];

const MaintenanceScheduled = () => {
  const [tasks, setTasks] = useState([]);
  const [archivedTasks, setArchivedTasks] = useState([]);
  // const [viewMode, setViewMode] = useState("list");
  const [task, setTask] = useState('');
  const [month, setMonth] = useState('');
  const [year, setYear] = useState('');
  const [type, setType] = useState(TYPE_OPTIONS[0]);
  const [done, setDone] = useState(false);
  const [activeTab, setActiveTab] = useState('tasks');
  const [editingTaskId, setEditingTaskId] = useState(null); // State to track editing

  const taskRef = useRef(null);
  const monthRef = useRef(null);
  const yearRef = useRef(null);


  useEffect(() => {
    const fetchTasks = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/maintenance/maintenanceScheduled`, {
          credentials: 'include'
        });
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setTasks(data);
      } catch (error) {
        console.error("Fetch error: ", error);
      }
    };

    fetchTasks();
    const intervalId = setInterval(fetchTasks, 5000);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    const fetchArchivedTasks = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/maintenance/maintenanceScheduled`, {
          credentials: 'include'
        });
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        setArchivedTasks(data);
      } catch (error) {
        console.error("Fetch error: ", error);
      }
    };

    fetchArchivedTasks();
  }, []);

  const handleAddOrUpdatedTask = async () => {


    // Validation
    if (!task) {
      if (taskRef.current) {
        taskRef.current.focus(); // Check if ref is available before calling focus
      }
      alert("Please fill out the task.");
      return;
    }

    if (!month) {
      if (monthRef.current) {
        monthRef.current.focus(); // Check if ref is available before calling focus
      }
      alert("Please fill out the month.");
      return;
    }

    if (!year) {
      if (yearRef.current) {
        yearRef.current.focus(); // Check if ref is available before calling focus
      }
      alert("Please fill out the year.");
      return;
    }
    const newTask = {
      task,
      month,
      year,
      type,
      done,
      archived: done
    };


    try {



      // const response = await fetch('http://localhost:8080/api/maintenance/maintenanceScheduled/createScheduled', {
      //   method: 'POST',
      //   headers: {
      //     'Content-Type': 'application/json',
      //   },
      //   body: JSON.stringify(newTask),
      // });

      // if (response.ok) {
      //   const addedTask = await response.json();
      //   setTasks([...tasks, addedTask]);

      //   if(addedTask.done){
      //     setArchivedTasks([...archivedTasks,addedTask]);
      //   }


      const response = await fetch(editingTaskId
        ? `${API_BASE_URL}/api/maintenance/maintenanceScheduled/${editingTaskId}`
        : `${API_BASE_URL}/api/maintenance/maintenanceScheduled/createScheduled`, {
        method: editingTaskId ? 'PUT' : 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(newTask),
      });

      if (response.ok) {
        const addedOrUpdatedTask = await response.json();
        if (editingTaskId) {
          setTasks(tasks.map(task => (task.id === editingTaskId ? addedOrUpdatedTask : task)));
          if (addedOrUpdatedTask.done) {
            setArchivedTasks(archivedTasks.map(task => (task.id === editingTaskId ? addedOrUpdatedTask : task)));
          }
        } else {
          setTasks([...tasks, addedOrUpdatedTask]);
          if (addedOrUpdatedTask.done) {
            setArchivedTasks([...archivedTasks, addedOrUpdatedTask]);
          }
        }







        setTask('');
        setMonth('');
        setYear('');
        setType(TYPE_OPTIONS[0]);
        setDone(false);
        setEditingTaskId(null); // Clear the editing task ID
      } else {
        console.error("Failed to add task");
      }
    } catch (error) {
      console.error("Fetch error: ", error);
    }
  };

  const handleDeleteTask = async (id) => {
    try {
      const response = await fetch(`${API_BASE_URL}/api/maintenance/maintenanceScheduled/${id}`, {
        method: 'DELETE',
        credentials: 'include'
      });

      if (response.ok) {
        setTasks(tasks.filter(task => task.id !== id));
        setArchivedTasks(archivedTasks.filter(task => task.id !== id));
      } else {
        console.error("Failed to delete task");
      }
    } catch (error) {
      console.error("Fetch error: ", error);
    }
  };

  const handleScheduleTask = async () => {
    //await handleAddOrUpdatedTask();
    alert("Task scheduled successfully!");
  };

  // Function to view task from archived tab
  const handleEditTask = (task) => {
    setTask(task.task);
    setMonth(task.month);
    setYear(task.year);
    setType(task.type);
    setDone(task.done);
    setEditingTaskId(task.id);
    // Switch to 'tasks' tab
    setActiveTab('tasks');
  };

  // const handleRefreshArchivedTasks = () => {
  //   fetchArchivedTasks();
  // };



  return (

    <div className="mx-auto ml-4 h-screen w-full mt-14">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-bold">Maintenance Scheduled</h2>
        <label className="flex items-center">
          <button
            onClick={() => setActiveTab('tasks')}
            className={`px-4 py-2 ${activeTab === 'tasks' ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
          >
            Tasks
          </button>
          <button
            onClick={() => setActiveTab('archived')}
            className={`px-4 py-2 ${activeTab === 'archived' ? 'bg-blue-500 text-white' : 'bg-gray-200'}`}
          >
            Archived Tasks
          </button>
        </label>
      </div>

      {/* {activeTab === 'tasks' && (
        <div>
          <div className="mb-4">
            <h2 className="text-xl font-semibold">Add Task</h2>
            <div className="flex flex-col mb-4">
              <label className="block mb-1 font-semibold">Task</label>
              <textarea
                value={task}
                onChange={(e) => setTask(e.target.value)}
                placeholder="Task"
                className="border px-4 py-2 mb-2 max-w-xs"
              />
              <label className="block mb-1 font-semibold">Month</label>
              <input
                type="text"
                value={month}
                onChange={(e) => setMonth(e.target.value)}
                placeholder="Month"
                className="border px-4 py-2 mb-2 max-w-xs"
              />
              <label className="block mb-1 font-semibold">Year</label>
              <input
                type="number"
                value={year}
                onChange={(e) => setYear(e.target.value)}
                placeholder="Year"
                className="border px-4 py-2 mb-2 max-w-xs"
              />
              <label className="block mb-1 font-semibold">Type</label>
              <select
                value={type}
                onChange={(e) => setType(e.target.value)}
                className="border px-4 py-2 mb-2 max-w-xs"
              >
                {TYPE_OPTIONS.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
              <div className="flex items-center mb-2">
              <input
                type="checkbox"
                checked={done}
                onChange={(e) => setDone(e.target.checked)}
                className="mr-2"
              />
             <label className="mr-2 font-semibold">Done</label>
              
              </div>
              
              <button
                onClick={handleAddOrUpdatedTask}
                className="px-4 py-2 bg-blue-500 text-white rounded-md max-w-xs"
              >
                Add Task
              </button>
              <button
                onClick={handleScheduleTask}
                className="px-4 py-2 bg-green-500 text-white rounded-md max-w-xs"
              >
                Schedule Task
              </button>
             
            </div>
          </div>

        </div>
      )}  */}


      {activeTab === 'tasks' && (
        <div className="flex justify-center items-center max-h-screen " >
          <div className="w-full max-w-md mt-8" >
            <h2 className="text-xl font-semibold mb-4 text-center">Add Task</h2>
            <div className="flex flex-col mb-4 space-y-4">
              <label className="block font-semibold">Task</label>
              <textarea
                value={task}
                onChange={(e) => setTask(e.target.value)}
                placeholder="Task"
                className="border px-4 py-2 mb-2 w-full h-64"
              />
              <label className="block font-semibold">Month</label>
              <input
                type="text"
                value={month}
                onChange={(e) => setMonth(e.target.value)}
                placeholder="Month"
                className="border px-4 py-2 mb-2"
              />
              <label className="block font-semibold">Year</label>
              <input
                type="number"
                value={year}
                onChange={(e) => setYear(e.target.value)}
                placeholder="Year"
                className="border px-4 py-2 mb-2"
              />
              <label className="block font-semibold">Type</label>
              <select
                value={type}
                onChange={(e) => setType(e.target.value)}
                className="border px-4 py-2 mb-2"
              >
                {TYPE_OPTIONS.map((option) => (
                  <option key={option} value={option}>
                    {option}
                  </option>
                ))}
              </select>
              <div className="flex items-center">
                <input
                  type="checkbox"
                  checked={done}
                  onChange={(e) => setDone(e.target.checked)}
                  className="mr-2"
                />
                <label className="font-semibold">Done</label>
              </div>
              <div className="flex space-x-2">
                <button
                  onClick={handleAddOrUpdatedTask}
                  className="border border-sss-accent-yel bg-sss-accent-yel rounded-lg px-6 py-2 flex text-sss-blue-sel font-bold
                        hover:bg-yellow-500 transition duration-300 ease-in-out"
                >
                  Add Task
                </button>
                <button
                  onClick={handleScheduleTask}
                  className="border border-blue-500 bg-blue-500 rounded-lg px-6 py-2 flex text-white font-bold hover:bg-blue-600 transition duration-300 ease-in-out"
                >
                  Schedule Task
                </button>
              </div>
            </div>
          </div>
        </div>
      )}



      {activeTab === 'archived' && (
        <div>
          <h2 className="text-xl font-semibold mb-4">Archived Tasks</h2>

          <ul className="space-y-4">
            {archivedTasks.map((task, key) => (
              <li
                key={key}
                className="bg-white p-4 rounded-lg shadow-lg border-2 border-gray-200 flex flex-col md:flex-row justify-between items-start md:items-center"
              >
                <div className="mb-2 md:mb-0 flex-1">
                  <h3 className="text-lg font-semibold">{task.task}</h3>
                  <p className="text-sm text-gray-600">Month: {task.month}</p>
                  <p className="text-sm text-gray-600">Year: {task.year}</p>
                  <p className="text-sm text-gray-600">Type: {task.type}</p>
                  <p className="text-sm text-gray-600">Done: {task.done ? "Yes" : "No"}</p>
                </div>
                <div className="flex space-x-2">
                  <button
                    onClick={() => handleDeleteTask(task.id)}
                    className="border border-sss-accent-yel bg-sss-accent-yel rounded-lg px-6 py-2 flex text-sss-blue-sel font-bold hover:bg-yellow-500 transition duration-300 ease-in-out"
                  >
                    Delete
                  </button>
                  <button
                    onClick={() => handleEditTask(task)}
                    className="border border-blue-500 bg-blue-500 rounded-lg px-6 py-2 flex text-white font-bold hover:bg-blue-600 transition duration-300 ease-in-out"
                  >
                    View
                  </button>
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default MaintenanceScheduled;